import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Pages publiques
import Mind from '../views/Mind';
import LoginPage from '../views/LoginPage';
import RegisterPage from '../views/RegisterPage';
import CGUPage from "../views/CGUPage";
import CGVentes from "../views/CGVentes";
import MentionsLegales from "../views/MentionsLegales";
import PolitiqueConfidentialite from "../views/PolitqueConfidentialite";
import LoginComptable from '../views/LoginComptable';
import NotFoundPage from '../views/404';

// Private Route
import PrivateRoute from './PrivateRoute';
import PrivateRouteComptable from './PrivateRouteComptable';

// Espace Client et ses composants
import EspaceClient from '../views/EspaceClient';
import Dashboard from '../components/Dashboard';
import ClientsList from '../components/ClientsList';
import DevisList from '../components/DevisList';
import ConsulterDevis from '../components/ConsulterDevis';
import ModifierDevis from '../components/ModifierDevis';
import AddDevis from '../components/AddDevis';
import FacturesList from '../components/FacturesList';
import ConsulterFacture from '../components/ConsulterFacture';
import AddFacture from '../components/AddFacture';
import ModifierFacture from '../components/ModifierFacture';
import Profil from '../components/Profil';
import Supports from '../components/Supports';
import Abonnement from '../components/Abonnement';
import RelanceFactureList from '../components/RelanceFactureList';
import RelanceDevisList from '../components/RelanceDevisList';
import Success from '../views/Success';
import Cancel from '../views/Cancel';

// Espace Comptable et composants
import EspaceComptable from '../views/EspaceComptable';
import DashboardComptable from '../components/DashboardComptable';
import ClientsListComptable from '../components/ClientsListComptable';
import DevisListComptable from '../components/DevisListComptable';
import ConsulterDevisComptable from '../components/ConsulterDevisComptable';
import FacturesListComptable from '../components/FacturesListComptable';
import ConsulterFactureComptable from '../components/ConsulterFactureComptable';
import AvoirsList from '../components/AvoirsList';
import AddAvoir from '../components/AddAvoir';
import ConsulterAvoir from '../components/ConsulterAvoir';
import ModifierAvoir from '../components/ModifierAvoir';
import PolitiqueCookies from '../views/PolitiqueCookies';
import LoginPageInfluenceur from '../views/LoginPageInfluenceur';
import PrivateRouteInfluenceur from './PrivateRouteInfluenceur';
import EspaceInfluenceur from '../views/EspaceInfluenceur';
import RegisterPageInfluenceur from '../views/RegisterPageInfluenceur';
import DeclarationAccessibilite from '../views/DeclarationAccessibilite';

const AppRouter = () => (
  <Router basename="/">
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Mind />} />
      <Route path="/influenceur/login" element={<LoginPageInfluenceur />} />
      <Route path="/influenceur/register" element={<RegisterPageInfluenceur />} />

      <Route path="/login" element={<LoginPage />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/conditions-ventes" element={<CGVentes />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      <Route path="/politique-cookies" element={<PolitiqueCookies />} />
      <Route path="/declaration-accessibilite" element={<DeclarationAccessibilite />} />

      <Route path="/conditions-utilisation" element={<CGUPage />} />
      <Route path="/newcompte" element={<RegisterPage />} />
      <Route path="/comptable/login" element={<LoginComptable />} />

      {/* Espace Client (Private) */}
      <Route
        path="/EspaceClient/*"
        element={
          <PrivateRoute redirectPath="/login">
            <EspaceClient />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="cancel" element={<Cancel />} />
        <Route path="success" element={<Success />} />

        {/* Clients */}
        <Route path="clients" element={<ClientsList />} />
        {/* Avoirs */}
        <Route path="avoirs" element={<AvoirsList />} />

        <Route path="avoirs/modifier/:id" element={<ModifierAvoir />} />
        <Route path="avoirs/consulter/:id" element={<ConsulterAvoir />} />
        <Route path="avoirs/modifier/:id" element={<AvoirsList />} />
        <Route path="avoirs/ajouter/:factureId" element={<AddAvoir />} />

        {/* Devis */}
        <Route path="devis" element={<DevisList />} />
        <Route path="devis/consulter/:id" element={<ConsulterDevis />} />
        <Route path="devis/modifier/:id" element={<ModifierDevis />} />
        <Route path="devis/ajouter" element={<AddDevis />} />

        {/* Factures */}
        <Route path="factures" element={<FacturesList />} />
        <Route path="facture/consulter/:id" element={<ConsulterFacture />} />
        <Route path="facture/ajouter" element={<AddFacture />} />
        <Route path="facture/modifier/:id" element={<ModifierFacture />} />

        {/* Autres */}
        <Route path="profil" element={<Profil />} />
        <Route path="support" element={<Supports />} />
        <Route path="abonnement" element={<Abonnement />} />
        <Route path="relances/factures" element={<RelanceFactureList />} />
        <Route path="relances/devis" element={<RelanceDevisList />} />
      </Route>

      {/* Espace Comptable (Private) */}
      <Route
        path="/EspaceCompta/*"
        element={
          <PrivateRouteComptable>
            <EspaceComptable />
          </PrivateRouteComptable>
        }
      >
        <Route index element={<DashboardComptable />} />

        {/* Clients */}
        <Route path="clients" element={<ClientsListComptable />} />

        {/* Devis */}
        <Route path="devis" element={<DevisListComptable />} />
        <Route path="devis/consulter/:id" element={<ConsulterDevisComptable />} />

        {/* Factures */}
        <Route path="factures" element={<FacturesListComptable />} />
        <Route path="facture/consulter/:id" element={<ConsulterFactureComptable />} />
      </Route>
      {/* Espace Influenceur (Private) */}
      <Route
        path="/influenceur/*"
        element={
          <PrivateRouteInfluenceur redirectPath="/influenceur/login">
            <EspaceInfluenceur />
          </PrivateRouteInfluenceur>
        }
      />
      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Router>
);

export default AppRouter;
